import { Action } from 'redux';
import { PatientState } from '../../patient/types';
import { PatientActions } from './actions';

const initialState: PatientState = {
  isFetching: false,
  isModifying: false,
  isEditingInsurance: false,
  error: null,
  data: [], // list of patients
  success: false,
};

function handleClearError(state: PatientState): PatientState {
  return {
    ...state,
    error: null,
  };
}

export function patientReducer(state: PatientState = initialState, action: Action & { data: any }): PatientState {
  switch (action.type) {
    case PatientActions.CLEAR_ERROR_PATIENT:
      return handleClearError(state);

    default:
      return state;
  }
}
